<template>
  <span>
    <!--
      Вызывается при изменении значения.

      @event input
      @property {String} value Тип отчета.
    -->
    <span
      style="margin-right: 20px;"
      class="type"
      :class="{ active: value === 'positions' }"
      @click="$emit('input', 'positions')"
    >Отчет по позициям</span>
    <span
      class="type"
      :class="{ active: value === 'money' }"
      @click="$emit('input', 'money')"
    >Отчет по деньгам</span>
  </span>
</template>

<script>

/**
 * Select для выбора типа отчета (по позициям, по деньгам).
 */
export default {
  name: 'TypeSelect',
  props: {
    /**
     * Тип отчета.
     *
     * @model
     */
    value: {
      type: String,
      required: true
    }
  }
}
</script>

<style scoped>
.type.active {
  font-weight: bold;
  border-bottom: none;
  cursor: default;
}

.type {
  border-bottom: 1px dashed;
  cursor: pointer;
  font-size: 16px;
}
</style>
